module.exports = __webpack_public_path__ + "static/media/cat-squashed.3ef038b7.gif";